<div class="form-grid">
  <label>
    <span>Language</span>
    <input [ngModel]="block.codeLanguage" placeholder="typescript" (ngModelChange)="updateCodeLanguage($event)" />
  </label>
</div>

<label>
  <span>Code</span>
  <textarea
    rows="8"
    class="code"
    [ngModel]="block.codeContent"
    placeholder="Paste code"
    (ngModelChange)="updateCodeContent($event)"></textarea>
</label>
